import type { QuippyBuildingSession, QuippyScope } from '../models';
import type { QuippyApi } from '../transport';
import { processDocumentSelection$ } from './document-selection';
import {
    processEditResendMessage$,
    processRetryMessage$,
    processSendMessage$,
} from './message-request-processing';
import type { MessageRequest } from './scope';

export function dispatchRequest$(
    request: MessageRequest,
    options: {
        api: QuippyApi;
        getSession: (scope: QuippyScope) => QuippyBuildingSession;
        updateSession: (
            scope: QuippyScope,
            updater: (session: QuippyBuildingSession) => QuippyBuildingSession
        ) => void;
    }
) {
    const common = {
        api: options.api,
        scope: request.scope,
        chatId: request.chatId,
        getSession: options.getSession,
        updateSession: options.updateSession,
    };
    switch (request.type) {
        case 'send':
            return processSendMessage$({
                ...common,
                userInput: request.userInput,
                adminMode: request.adminMode,
            });
        case 'retry':
            return processRetryMessage$({
                ...common,
                messageId: request.messageId,
                adminMode: request.adminMode,
            });
        case 'edit-resend':
            return processEditResendMessage$({
                ...common,
                messageId: request.messageId,
                userInput: request.userInput,
                adminMode: request.adminMode,
            });
        case 'select-document':
            return processDocumentSelection$({
                ...common,
                messageId: request.messageId,
                fileId: request.fileId,
            });
    }
}
